function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  className: "cls-1",
  d: "M55.481,9.519A32.509,32.509,0,0,0,12.218,7.1a.966.966,0,1,0,1.208,1.508,30.577,30.577,0,0,1,40.689,2.278,30.568,30.568,0,0,1-43.23,43.23,30.569,30.569,0,0,1-.5-42.715.966.966,0,0,0-1.4-1.334,32.5,32.5,0,0,0,46.5,45.415,32.5,32.5,0,0,0,0-45.963Z",
  transform: "translate(0)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  className: "cls-1",
  d: "M77.419,108.716a24.9,24.9,0,1,0-4.2-1.8.966.966,0,1,0,.923-1.7,22.769,22.769,0,1,1,3.871,1.663.966.966,0,1,0-.595,1.838Z",
  transform: "translate(-52.559 -52.559)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  "data-name": "Path 83",
  className: "cls-1",
  d: "M110.623,204.008a7.393,7.393,0,0,0,10.451,6.626,1.39,1.39,0,0,1,1.435.207,7.592,7.592,0,0,0,2.071,1.264,7.392,7.392,0,0,0,5.045-13.9l-.2-.072a12.462,12.462,0,0,1-6.065-4.828,12.051,12.051,0,0,0-4.5-4.329,7.392,7.392,0,0,0-8.344,11.867,1.347,1.347,0,0,1,.328,1.252,7.41,7.41,0,0,0-.222,1.908Zm.244-10.5a5.466,5.466,0,0,1,7.208-2.767,10.5,10.5,0,0,1,3.683,3.637,14.382,14.382,0,0,0,7,5.567l.2.074h0a5.46,5.46,0,0,1-3.725,10.264,5.627,5.627,0,0,1-1.517-.951,3.347,3.347,0,0,0-2.1-.755,3.241,3.241,0,0,0-1.346.293,5.4,5.4,0,0,1-2.488.484,5.463,5.463,0,0,1-5.066-6.789,3.294,3.294,0,0,0-.806-3.061A5.441,5.441,0,0,1,110.867,193.513Z",
  transform: "translate(-94.689 -164.431)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  className: "cls-1",
  d: "M216.89,121.043a5.926,5.926,0,0,1,2.511.634.966.966,0,0,0,.879-1.72,7.868,7.868,0,0,0-3.334-.844,7.1,7.1,0,0,0-7.543,6.581,4.063,4.063,0,0,0,2.308,4.046,11.558,11.558,0,0,0,4.9.924c.288.008.626.018,1,.018,2.464,0,6.368-.43,6.487-4.564a6.326,6.326,0,0,0-.37-2.324.966.966,0,1,0-1.819.652,4.4,4.4,0,0,1,.257,1.617c-.05,1.745-.987,2.8-5.5,2.67a10.667,10.667,0,0,1-4.083-.715,2.164,2.164,0,0,1-1.252-2.268,5.169,5.169,0,0,1,5.556-4.705Z",
  transform: "translate(-182.816 -103.987)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  className: "cls-1",
  d: "M322.681,204.874a.966.966,0,1,0,0-1.932h-1.668c-.616-2.627-1.954-4.194-3.747-4.194s-3.077,1.517-3.649,4.194h-1.664a.966.966,0,1,0,0,1.932h1.392q-.045.569-.059,1.183h-1.333a.966.966,0,1,0,0,1.932h1.376a16.184,16.184,0,0,0,.194,1.652l-.884.422a.966.966,0,0,0-.455,1.288c.288.658,1.2.636,1.839.192.675,1.794,1.788,2.786,3.243,2.786s2.6-1.024,3.312-2.8l.583.278a1.013,1.013,0,0,0,1.288-.455.966.966,0,0,0-.455-1.288l-.878-.419a14.906,14.906,0,0,0,.217-1.656h1.347a.966.966,0,1,0,0-1.932h-1.3q-.015-.612-.066-1.183Zm-5.414,7.524c-1.19,0-2.053-2.464-2.053-5.859s.863-5.859,2.053-5.859c1.249,0,2.19,2.519,2.19,5.859S318.515,212.4,317.267,212.4Z",
  transform: "translate(-271.506 -173.515)"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_37",
  "data-name": "Ellipse 37",
  className: "cls-1",
  cx: 1.208,
  cy: 1.208,
  r: 1.208,
  transform: "translate(19.863 29.043) rotate(-13.3)"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_38",
  "data-name": "Ellipse 38",
  className: "cls-1",
  cx: 1.208,
  cy: 1.208,
  r: 1.208,
  transform: "translate(20.253 34.494) rotate(-45)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_39",
  "data-name": "Ellipse 39",
  className: "cls-1",
  cx: 1.208,
  cy: 1.208,
  r: 1.208,
  transform: "translate(28.981 37.108)"
});

var SvgBiochemical = function SvgBiochemical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0411\\u0456\\u043E\\u0445\\u0456\\u043C\\u0456\\u0447\\u043D\\u0456",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBiochemical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/biochemical.4a4014c2.svg";
export { ForwardRef as ReactComponent };